import { Link } from "react-router-dom";
import { CONTACT, PRESTATIONS, IMAGES } from "@/lib/data";
import { TID } from "@/lib/testIds";
import Marquee from "./Marquee";
import OptimizedImage from "@/components/OptimizedImage";

export default function Footer() {
    return (
        <footer
            data-testid={TID.footer}
            className="relative bg-brown text-creme"
        >
            {/* Marquee band */}
            <div className="border-y border-creme/10 py-6 overflow-hidden">
                <Marquee
                    speed={55}
                    items={[
                        "Réflexologie plantaire",
                        "·",
                        "Réflexologie palmaire",
                        "·",
                        "Dien Chan",
                        "·",
                        "Chan'Beauté",
                        "·",
                        "Challes-les-Eaux · Savoie",
                        "·",
                        "Stress & tensions",
                        "·",
                        "Sommeil",
                        "·",
                        "Lâcher-prise",
                        "·",
                        "06 63 34 03 97",
                        "·",
                    ]}
                    itemClassName="font-serif text-4xl md:text-6xl text-creme italic"
                />
            </div>

            <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
                <div className="lg:col-span-5">
                    <OptimizedImage
                        src={IMAGES.logoWhite}
                        srcSet={IMAGES.logoWhiteSrcSet}
                        sizes="(max-width: 768px) 96px, 112px"
                        alt="Joëlle Berthaud — Réflexologue"
                        className="h-12 md:h-14 w-auto"
                        width={202}
                        height={91}
                        loading="lazy"
                        decoding="async"
                    />
                    <p className="mt-6 text-creme/70 text-sm leading-relaxed max-w-md">
                        Réflexologue à Challes-les-Eaux (Savoie). J&apos;accompagne
                        le stress, le sommeil et les tensions par la réflexologie
                        plantaire, palmaire, faciale Dien Chan et Chan&apos;Beauté.
                        Soin complémentaire — ne remplace pas un suivi médical.
                    </p>
                </div>

                <div className="lg:col-span-3">
                    <div className="text-xs uppercase tracking-widest text-creme/80 mb-4">
                        Naviguer
                    </div>
                    <ul className="space-y-2 text-sm">
                        <li>
                            <Link to="/a-propos" className="hover:text-terracotta">
                                À propos
                            </Link>
                        </li>
                        <li>
                            <Link to="/prestations" className="hover:text-terracotta">
                                Prestations
                            </Link>
                        </li>
                        <li>
                            <Link to="/tarifs" className="hover:text-terracotta">
                                Tarifs
                            </Link>
                        </li>
                        <li>
                            <Link to="/entreprises" className="hover:text-terracotta">
                                Entreprises & ateliers
                            </Link>
                        </li>
                        <li>
                            <Link to="/premiere-seance" className="hover:text-terracotta">
                                Première séance
                            </Link>
                        </li>
                        <li>
                            <Link to="/guides" className="hover:text-terracotta">
                                Guides
                            </Link>
                        </li>
                        <li>
                            <Link to="/proximite" className="hover:text-terracotta">
                                À proximité
                            </Link>
                        </li>
                        <li>
                            <Link to="/faq" className="hover:text-terracotta">
                                FAQ
                            </Link>
                        </li>
                        <li>
                            <Link to="/contact" className="hover:text-terracotta">
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="lg:col-span-2">
                    <div className="text-xs uppercase tracking-widest text-creme/80 mb-4">
                        Prestations
                    </div>
                    <ul className="space-y-2 text-sm">
                        {PRESTATIONS.map((p) => {
                            const label = p.name
                                .replace(/^Réflexologie\s+/i, "")
                                .replace(/^./, (c) => c.toUpperCase());
                            return (
                                <li key={p.slug}>
                                    <Link
                                        to={`/prestations/${p.slug}`}
                                        className="hover:text-terracotta"
                                    >
                                        {label}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                <div className="lg:col-span-2">
                    <div className="text-xs uppercase tracking-widest text-creme/80 mb-4">
                        Cabinet
                    </div>
                    <address className="not-italic text-sm text-creme/80 space-y-1">
                        <div>{CONTACT.address.street}</div>
                        <div>
                            {CONTACT.address.zip} {CONTACT.address.city}
                        </div>
                        <div>{CONTACT.address.region}, France</div>
                    </address>
                    <a
                        href={`tel:${CONTACT.phoneRaw}`}
                        className="mt-4 block text-sm hover:text-terracotta"
                    >
                        {CONTACT.phone}
                    </a>
                    <a
                        href={`mailto:${CONTACT.email}`}
                        className="mt-1 block text-sm text-creme/70 hover:text-terracotta break-all"
                    >
                        {CONTACT.email}
                    </a>
                </div>
            </div>

            <div className="border-t border-creme/10">
                <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-creme/80">
                    <div>
                        © {new Date().getFullYear()} Joëlle Berthaud — Tous
                        droits réservés
                    </div>
                    <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
                        <Link to="/mentions-legales" className="hover:text-terracotta">
                            Mentions légales & confidentialité
                        </Link>
                        <a
                            href="https://www.gallusia.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-terracotta"
                        >
                            Développé par Gallusia Group
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
